import { Flex, Modal } from "antd";
import { FC, ReactNode } from "react";

import BaseButton from "@/shared/ui/BaseButton";
import { PrimaryText } from "@/shared/ui/Typography";

import { StyledDangerIcon } from "./Styled";

export interface WarningModalProps {
    modalKey?: string;
    isModalOpened: boolean;
    confirm?: () => void;
    cancel: () => void;
    title?: string;
    children: ReactNode;
    width?: string;
    maskClosable?: boolean;
    isLoadingConfirm?: boolean;
    isVisibleAlarm?: boolean;
}

export const WarningModal: FC<WarningModalProps> = ({
    modalKey,
    isModalOpened,
    confirm,
    cancel,
    width,
    title = "Ви впевнені?",
    children,
    maskClosable = true,
    isLoadingConfirm = false,
    isVisibleAlarm = true,
}) => {
    const visibleAlarm = isVisibleAlarm;
    return (
        <Modal
            key={modalKey}
            open={isModalOpened}
            onOk={() => confirm?.()}
            onCancel={() => cancel()}
            centered
            footer={[]}
            width={width}
            mask={{ closable: maskClosable }}
        >
            {visibleAlarm ? <StyledDangerIcon /> : <></>}
            <PrimaryText
                fontSize={20}
                fontWeight="500"
                style={{ textAlign: "center", marginBottom: 16 }}
            >
                {title}
            </PrimaryText>
            {children}

            <Flex vertical gap={8} style={{ marginTop: 24 }}>
                {confirm && (
                    <BaseButton
                        type="primary"
                        bgColor="success"
                        onClick={() => confirm()}
                        loading={isLoadingConfirm}
                    >
                        Підтвердити
                    </BaseButton>
                )}

                <BaseButton type="default" onClick={() => cancel()}>
                    Повернутися назад
                </BaseButton>
            </Flex>
        </Modal>
    );
};
